import React, {useCallback, useEffect, useRef, useState} from "react";
import {useTheme} from "@mui/material/styles";
import "nodeEditor/nodeEditor.css";
import createEditor from "nodeEditor/createEditor";
import {useGetNodeFileList} from "hooks/useGetNodeFileList";
import {useGetNodeFileGroups} from "hooks/useGetNodeVideoGroups";
import { EditorContainer } from './NodeEditor.styles';

interface NodeEditorProps {
    onEditorChange: (editor: object) => void;
    config?: object | null;
    lessonId?: string,
}
export const NodeEditor = (props: NodeEditorProps) => {
    const {onEditorChange, config, lessonId} = props;
    const {fetchNodeFileList} = useGetNodeFileList();
    const {fetchNodeFileGroups} = useGetNodeFileGroups();
    const [editor, setEditor] = useState<object>();
    const editorRef = useRef(editor);
    const theme = useTheme();

    const handleEditorLoaded = useCallback((editor: object) => {
        setEditor(editor);
    }, []);


    const handleEditorChange = useCallback(() => {
        if (!editorRef.current) return;
        onEditorChange(editorRef.current);
    }, [onEditorChange]);

    const nodeEditorRef = useCallback((container: any) => {
        if (container) {
            container.innerHTML = "";
            createEditor(
                container,
                config,
                handleEditorChange,
                handleEditorLoaded,
                fetchNodeFileList,
                fetchNodeFileGroups,
                lessonId
            );
        }
    }, [config, handleEditorChange, handleEditorLoaded, fetchNodeFileList, fetchNodeFileGroups, lessonId]);

    useEffect(() => {
        editorRef.current = editor;
        handleEditorChange();
    }, [editor]);

    return (
        <EditorContainer ref={nodeEditorRef} className="rete" id="rete"></EditorContainer>
    );
}